import styled from 'styled-components'
import AdIcon from '@signal/components/Icons/Ad'
import { getSpacingSelector } from '@signal/theme/selectors'

export const Icon = styled(AdIcon)`
  margin-right: ${getSpacingSelector()}px;
`
